export function stopEvent(event: Event) {
  if (typeof event.stopPropagation === 'function') {
    event.stopPropagation();
  }

  if (typeof event.preventDefault === 'function') {
    event.preventDefault();
  }
}
